define.alias("shared/modifiers/css-properties", "calendar/modifiers/css-properties");